import { useQuery } from "@tanstack/react-query";
import { clientAPI } from "../../api/client";

async function fetchConstantData() {
  const searchOptions = {
    limit: 10000000,
    page: 1,
  };

  // if (projectId){
  //   searchOptions.status = 'OPEN';
  // }
  const searchQueryParams = new URLSearchParams(searchOptions).toString();

  // Fetch constant data concurrently
  const [project] = await Promise.all([
    clientAPI("get", `/project?${searchQueryParams}`),
  ]);

  // Index data by 'id' to improve lookup performance
  return {
    project: project?.items?.reduce(
      (acc, item) => ({ ...acc, [item._id]: item.name }),
      {}
    ),
  };
}

export function useCategories(shouldFetch) {
  // Fetch constant data once
  const {
    data: constantData,
    isLoading,
    isFetching,
    refetch,
  } = useQuery({
    queryKey: ["categories4"],
    queryFn: () => fetchConstantData(),
    enabled: shouldFetch,
    refetchOnWindowFocus: false,
  });

  return {
    constantData,
    isLoading,
    isFetching,
    refetch,
  };
}
